import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full flex" }
const _hoisted_2 = { class: "flex flex-wrap justify-between p-2" }
const _hoisted_3 = { class: "text-blue-900 font-bold text-left border-l-4 border-blue-900" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "text-blue-900 pr-2 font-mono" }
const _hoisted_6 = { class: "infomation flex flex-wrap md:flex-none space-x-0 space-y-2 md:space-x-2 md:space-y-0 mb-2" }
const _hoisted_7 = { class: "md:w-[400px] w-full bg-white bg-opacity-80 p-4 rounded-sm shadow-md" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "mt-2" }
const _hoisted_10 = { class: "pr-1 font-mono text-sm text-blue-900 font-bold" }
const _hoisted_11 = { class: "text-gray-500 font-mono" }
const _hoisted_12 = {
  key: 1,
  class: "cursor-pointer"
}
const _hoisted_13 = { class: "social-media flex space-x-3 mt-2 w-[100px] mx-auto" }
const _hoisted_14 = { class: "md:w-[calc(100%-410px)] w-full bg-white bg-opacity-80 p-6 rounded-sm shadow-md relative" }
const _hoisted_15 = { class: "text-xl text-left underline font-mono font-bold text-blue-900 mb-6" }
const _hoisted_16 = { class: "space-y-4" }
const _hoisted_17 = { class: "flex items-start" }
const _hoisted_18 = { class: "font-semibold text-gray-600 w-1/3 text-left" }
const _hoisted_19 = { class: "flex items-start" }
const _hoisted_20 = { class: "font-semibold text-gray-600 w-1/3 text-left" }
const _hoisted_21 = { class: "flex items-start" }
const _hoisted_22 = { class: "font-semibold text-gray-600 w-1/3 text-left" }
const _hoisted_23 = { class: "flex items-start" }
const _hoisted_24 = { class: "font-semibold text-gray-600 w-1/3 text-left" }
const _hoisted_25 = { class: "flex items-start" }
const _hoisted_26 = { class: "font-semibold text-gray-600 w-1/3 text-left" }
const _hoisted_27 = { class: "flex items-start" }
const _hoisted_28 = { class: "font-semibold text-gray-600 w-1/3 text-left" }
const _hoisted_29 = { class: "flex items-start" }
const _hoisted_30 = { class: "font-semibold text-gray-600 w-1/3 text-left" }
const _hoisted_31 = { class: "flex items-start" }
const _hoisted_32 = { class: "font-semibold text-gray-600 w-1/3 text-left" }
const _hoisted_33 = { class: "Activity flex flex-wrap md:flex-none space-x-0 space-y-2 md:space-x-2 md:space-y-0" }
const _hoisted_34 = { class: "md:w-[calc(100%-410px)] w-full bg-white bg-opacity-80 p-6 rounded-sm shadow-md relative" }
const _hoisted_35 = { class: "text-xl text-left underline font-mono font-bold text-blue-900 mb-6" }
const _hoisted_36 = { class: "space-y-4 content" }

import siderComponent from "@/components/account/siderComponent.vue";
import { User } from "@/models/user";
import { getRole, getUser } from "@/services/auth/authService";
import { ref, onMounted } from "vue";
import ModalUpdateInformationAccount from "@/components/account/modalUpdateInformationAccount.vue";
import {
  UserOutlined,
  LinkOutlined,
  FacebookOutlined,
  GithubOutlined,
  TwitterOutlined,
  EditOutlined,
} from "@ant-design/icons-vue";
import i18n from "@/services/i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountInfomation',
  setup(__props) {

const user = ref<User | null>(null);
const bio = ref<string>("");

onMounted(async () => {
  user.value = await getUser();
});
const isVisible = ref(false);
const isBioEdit = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_timeline_item = _resolveComponent("a-timeline-item")!
  const _component_a_timeline = _resolveComponent("a-timeline")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, { class: "min-h-screen flex" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_sider, { class: "hidden md:block bg-white w-64 shadow-md" }, {
          default: _withCtx(() => [
            _createVNode(siderComponent)
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout, { class: "flex-1" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", _hoisted_3, "   " + _toDisplayString(_unref(i18n).global.t(
                "NAVIGATION_SECTION.ACCOUNT_SECTION.PERSONAL_INFORMATION"
              )), 1),
              _createElementVNode("p", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, _toDisplayString(user.value?.email), 1),
                _createVNode(_component_a_tag, {
                  color: "#3b5999",
                  class: "bg-blue-900 text-white font-mono"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getRole)()), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createVNode(_component_a_layout_content, { class: "my-2 bg-gray-300 bg-opacity-10 p-2" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_a_badge, { count: 99 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_avatar, {
                            shape: "square",
                            class: "w-24 h-24"
                          }, {
                            icon: _withCtx(() => [
                              _createVNode(_unref(UserOutlined), { class: "text-6xl" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString("Nguyễn văn đạt".toUpperCase()), 1),
                        _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(user.value?.username), 1)
                      ]),
                      _createElementVNode("div", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (isBioEdit.value = true)),
                        class: "relative p-4 min-h-[100px] font-mono text-gray-500 mt-1 bg-gray-200 bg-opacity-15 truncate"
                      }, [
                        (isBioEdit.value)
                          ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                              key: 0,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((bio).value = $event)),
                              placeholder: "...",
                              onBlur: _cache[1] || (_cache[1] = 
                      () => {
                        isBioEdit.value = false;
                      }
                    ),
                              class: "bg-opacity-0 bg-none w-full h-full border-none focus:border-none hover:border-none focus:outline-none focus:ring-0 focus:shadow-none focus:bg-blue-100 focus:bg-opacity-0"
                            }, null, 544)), [
                              [_vModelText, bio.value]
                            ])
                          : _createCommentVNode("", true),
                        (!isBioEdit.value)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(bio.value || _ctx.$t("empty.description")), 1))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(EditOutlined), {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (isBioEdit.value = true)),
                          class: "text-gray-400 absolute top-1 right-1"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_a_popover, {
                          title: "Facebook",
                          trigger: "click"
                        }, {
                          content: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              size: "small",
                              class: "hover:border-blue-900 focus:border-blue-900 focus:outline-none focus:ring-0 focus:shadow-none focus:bg-amber-900 border-blue-900 font-mono"
                            }, {
                              suffix: _withCtx(() => [
                                _createVNode(_unref(LinkOutlined), { class: "text-xl text-blue-900 pb-2" })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(FacebookOutlined), { class: "text-xl text-blue-900" })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(GithubOutlined), { class: "text-xl text-gray-200" }),
                        _createVNode(_unref(TwitterOutlined), { class: "text-xl text-gray-200" })
                      ])
                    ]),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "mt-6" }, null, -1))
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("h3", _hoisted_15, " I." + _toDisplayString(_ctx.$t("nav.account.informationProfile").toUpperCase()), 1),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("nav.account.profile.name")) + " :", 1),
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-gray-800 font-mono w-2/3 text-left" }, "NGUYỄN VĂN ĐẠT", -1))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("nav.account.profile.address")) + " :", 1),
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-gray-800 font-mono w-2/3 text-left" }, "123 Đường ABC, Quận 1, TP.HCM", -1))
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("nav.account.profile.phone")) + " :", 1),
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-gray-800 font-mono w-2/3 text-left" }, "0901234567", -1))
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("nav.account.profile.dob")) + " :", 1),
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-gray-800 font-mono w-2/3 text-left" }, "01/01/1990", -1))
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("nav.account.profile.nickname")) + " :", 1),
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-gray-800 w-2/3 font-mono text-left" }, "van_a_pro", -1))
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("nav.account.profile.hobbies")) + " :", 1),
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-gray-800 font-mono w-2/3 text-left" }, "Đọc sách, Du lịch, Chơi game", -1))
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("nav.account.profile.createdTime")) + " :", 1),
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-gray-500 font-mono w-2/3 text-left" }, "2025-01-13 09:43:58", -1))
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("nav.account.profile.updatedTime")) + " :", 1),
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-gray-500 font-mono w-2/3 text-left" }, "2025-01-13 09:43:58", -1))
                      ])
                    ]),
                    _createVNode(_unref(EditOutlined), {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (isVisible.value = true)),
                      class: "text-blue-900 absolute bottom-2 right-2 text-xl hover:text-2xl hover:text-blue-900"
                    }),
                    _createVNode(ModalUpdateInformationAccount, {
                      isVisible: isVisible.value,
                      user: null,
                      "onUpdate:isVisible": _cache[5] || (_cache[5] = ($event: any) => (isVisible.value = $event))
                    }, null, 8, ["isVisible"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "md:w-[400px] w-full p-0 rounded-sm relative" }, null, -1)),
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("h3", _hoisted_35, " II." + _toDisplayString(_ctx.$t("nav.account.historyActivity").toUpperCase()), 1),
                    _createElementVNode("div", _hoisted_36, [
                      _createVNode(_component_a_timeline, null, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (index) => {
                            return _createVNode(_component_a_timeline_item, {
                              key: index,
                              class: "text-left",
                              color: "rgb(30 58 138)"
                            }, {
                              default: _withCtx(() => [
                                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "font-mono" }, " Create a services site 2015-09-01 - Event", -1)),
                                _createTextVNode(" " + _toDisplayString(index), 1)
                              ]),
                              _: 2
                            }, 1024)
                          }), 64))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_pagination, {
                        size: "small",
                        total: 100,
                        class: "custom-pagination"
                      })
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_layout_footer, { class: "bg-gray-300 bg-opacity-10" })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})